(() => {
  const formatMoney = (cents) => {
    const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : "USD";

    return new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency
    }).format((Number(cents) || 0) / 100);
  };

  document.querySelectorAll("[data-product-form]").forEach((form) => {
    const jsonEl = form.querySelector("[data-product-json]");
    if (!jsonEl) return;

    let product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (_error) {
      return;
    }

    const idInput = form.querySelector('input[name="id"]');
    const priceEl = document.querySelector("[data-product-price]");
    const submit = form.querySelector('button[type="submit"]');
    const selectors = Array.from(form.querySelectorAll("[data-option-position]"));

    const syncVariant = () => {
      const selected = selectors.map((select) => select.value);
      const variant = product.variants.find((candidate) => {
        return selected.every((value, index) => candidate.options[index] === value);
      });

      if (!variant) return;

      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? "Add to bag" : "Unavailable";
      }
    };

    selectors.forEach((select) => select.addEventListener("change", syncVariant));
  });

  document.querySelectorAll("[data-media-preview]").forEach((button) => {
    button.addEventListener("click", () => {
      const section = button.closest(".product-archive");
      const image = section && section.querySelector(".product-archive__media .case-silhouette img");
      const next = button.getAttribute("data-media-preview");
      if (image && next) image.src = next;
    });
  });
})();

/* CASEPHON Shopify bag bridge */
(function () {
  var CART_URL = "/cart.js";
  var ADD_URL = "/cart/add.js";
  var CHANGE_URL = "/cart/change.js";
  var state = { cart: null, busy: false };

  function money(cents) {
    return "$" + (Number(cents || 0) / 100).toFixed(2);
  }

  function escapeHTML(value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function cartCount(cart) {
    return Number(cart && cart.item_count ? cart.item_count : 0);
  }

  function optionText(item) {
    var options = Array.isArray(item.options_with_values) ? item.options_with_values : [];
    return options
      .filter(function (option) {
        return option && option.value && option.value !== "Default Title";
      })
      .map(function (option) {
        return option.name + ": " + option.value;
      });
  }

  function ensureCartShell() {
    if (document.querySelector("[data-cart-drawer]")) return;
    document.body.insertAdjacentHTML(
      "beforeend",
      [
        '<button class="cart-launcher" type="button" data-cart-launcher aria-label="Open cart">',
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">',
        '<path d="M6 7h12l-1 13H7L6 7z"></path>',
        '<path d="M9 7V5a3 3 0 0 1 6 0v2"></path>',
        "</svg>",
        '<span class="cart-count is-empty" data-cart-count>0</span>',
        "</button>",
        '<div class="cart-backdrop" data-cart-backdrop></div>',
        '<aside class="cart-drawer" data-cart-drawer aria-hidden="true">',
        '<header class="cart-drawer-header">',
        "<h2>Your bag</h2>",
        '<button class="cart-close" type="button" data-cart-close aria-label="Close cart">×</button>',
        "</header>",
        '<div class="cart-items" data-cart-items></div>',
        '<footer class="cart-drawer-footer">',
        '<div class="cart-total-line"><span>Total</span><strong data-cart-total>$0.00</strong></div>',
        '<button class="cart-checkout" type="button" data-cart-checkout>Checkout</button>',
        "</footer>",
        "</aside>"
      ].join("")
    );
  }

  function setCartOpen(open) {
    ensureCartShell();
    var drawer = document.querySelector("[data-cart-drawer]");
    var backdrop = document.querySelector("[data-cart-backdrop]");
    if (!drawer || !backdrop) return;
    drawer.classList.toggle("is-open", open);
    backdrop.classList.toggle("is-open", open);
    drawer.setAttribute("aria-hidden", open ? "false" : "true");
  }

  function renderCart(cart) {
    ensureCartShell();
    var current = cart || state.cart || { items: [], item_count: 0, total_price: 0 };
    state.cart = current;
    var count = cartCount(current);

    document.querySelectorAll("[data-cart-count]").forEach(function (node) {
      node.textContent = count;
      node.classList.toggle("is-empty", count === 0);
    });
    document.querySelectorAll(".nav-bag em").forEach(function (node) {
      node.textContent = String(count);
    });

    var list = document.querySelector("[data-cart-items]");
    var total = document.querySelector("[data-cart-total]");
    var checkout = document.querySelector("[data-cart-checkout]");
    if (total) total.textContent = money(current.total_price);
    if (checkout) checkout.disabled = count === 0 || state.busy;
    if (!list) return;

    if (!current.items || !current.items.length) {
      list.innerHTML = '<div class="cart-empty">Your bag is empty.<br />Add a case to start an order.</div>';
      return;
    }

    list.innerHTML = current.items
      .map(function (item) {
        var image = item.image || item.featured_image && item.featured_image.url || "";
        var url = item.url || "#";
        var options = optionText(item);
        var meta = options.length ? options : [item.variant_title || "As shown"];
        return [
          '<article class="cart-item" data-cart-key="' + escapeHTML(item.key) + '">',
          '<a class="cart-item-media" href="' + escapeHTML(url) + '">',
          image ? '<img src="' + escapeHTML(image) + '" alt="' + escapeHTML(item.product_title || item.title) + '">' : "",
          "</a>",
          '<div class="cart-item-copy">',
          '<a class="cart-item-link" href="' + escapeHTML(url) + '">',
          '<h3 class="cart-item-title">' + escapeHTML(item.product_title || item.title) + "</h3>",
          '<div class="cart-item-meta">' + meta.map(function (line) { return "<span>" + escapeHTML(line) + "</span>"; }).join("") + "</div>",
          "</a>",
          '<div class="cart-item-bottom">',
          '<div class="quantity-control" aria-label="Quantity">',
          '<button type="button" data-cart-decrease aria-label="Decrease quantity">−</button>',
          "<span>" + Number(item.quantity || 1) + "</span>",
          '<button type="button" data-cart-increase aria-label="Increase quantity">+</button>',
          "</div>",
          '<strong class="cart-item-price">' + money(item.final_line_price) + "</strong>",
          "</div>",
          '<button class="cart-remove" type="button" data-cart-remove>Remove</button>',
          "</div>",
          "</article>"
        ].join("");
      })
      .join("");
  }

  function request(url, payload) {
    return fetch(url, {
      method: payload ? "POST" : "GET",
      headers: payload ? { "Content-Type": "application/json" } : {},
      body: payload ? JSON.stringify(payload) : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart request failed");
      return response.json();
    });
  }

  function refreshCart() {
    return request(CART_URL).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  function changeItem(key, quantity) {
    state.busy = true;
    renderCart();
    return request(CHANGE_URL, { id: key, quantity: Math.max(0, quantity) })
      .then(function (cart) {
        state.busy = false;
        renderCart(cart);
        return cart;
      })
      .catch(function (error) {
        state.busy = false;
        renderCart();
        throw error;
      });
  }

  function addVariant(variantId, quantity) {
    state.busy = true;
    renderCart();
    return request(ADD_URL, { items: [{ id: Number(variantId), quantity: Number(quantity || 1) }] })
      .then(refreshCart)
      .then(function (cart) {
        state.busy = false;
        renderCart(cart);
        setCartOpen(true);
        return cart;
      })
      .catch(function (error) {
        state.busy = false;
        renderCart();
        throw error;
      });
  }

  function selectedVariantIdFromPage() {
    var formId = document.querySelector("[data-cf-variant-id]");
    if (formId && formId.value) return formId.value;

    var selected = {};
    document.querySelectorAll(".option-select").forEach(function (select) {
      var pos = select.getAttribute("data-pos") || select.getAttribute("data-cf-option-position");
      if (pos) selected[pos] = select.value;
    });
    document.querySelectorAll(".style-options").forEach(function (group) {
      var button = group.querySelector(".style-choice.is-selected");
      var pos = group.getAttribute("data-pos") || button && button.getAttribute("data-pos");
      if (button && pos) selected[pos] = button.getAttribute("data-val") || button.textContent.trim();
    });

    var scripts = Array.from(document.scripts).map(function (script) { return script.textContent || ""; });
    var source = scripts.find(function (text) { return text.indexOf("const VARIANTS =") >= 0; }) || "";
    var match = source.match(/const VARIANTS = (\\[.*?\\]);\\s*const OPTION_DEFS =/s);
    if (!match) return "";
    try {
      var variants = JSON.parse(match[1]);
      var positions = Object.keys(selected);
      var variant = variants.find(function (entry) {
        return positions.every(function (pos) {
          return entry["option" + pos] === selected[pos];
        });
      }) || variants[0];
      return variant && variant.id;
    } catch (error) {
      return "";
    }
  }

  function bindEvents() {
    document.addEventListener("click", function (event) {
      var productAdd = event.target.closest("#addToCartBtn, [data-cf-submit]");
      var productCheckout = event.target.closest("#checkoutBtn");
      if (productAdd || productCheckout) {
        var variantId = selectedVariantIdFromPage();
        if (variantId) {
          event.preventDefault();
          event.stopImmediatePropagation();
          addVariant(variantId, 1).then(function () {
            if (productCheckout) window.location.href = "/checkout";
          });
          return;
        }
      }

      var cartLink = event.target.closest("[data-cart-launcher], a[href='#cart'], a[href='/cart'], a[href$='/cart']");
      if (cartLink) {
        event.preventDefault();
        refreshCart().finally(function () { setCartOpen(true); });
        return;
      }

      if (event.target.closest("[data-cart-close]") || event.target.closest("[data-cart-backdrop]")) {
        setCartOpen(false);
        return;
      }

      if (event.target.closest("[data-cart-checkout]")) {
        if (state.cart && cartCount(state.cart) > 0) window.location.href = "/checkout";
        return;
      }

      var item = event.target.closest("[data-cart-key]");
      if (!item || !state.cart) return;
      var key = item.getAttribute("data-cart-key");
      var line = (state.cart.items || []).find(function (entry) { return entry.key === key; });
      if (!line) return;

      if (event.target.closest("[data-cart-increase]")) {
        changeItem(key, Number(line.quantity || 1) + 1);
      } else if (event.target.closest("[data-cart-decrease]")) {
        changeItem(key, Number(line.quantity || 1) - 1);
      } else if (event.target.closest("[data-cart-remove]")) {
        changeItem(key, 0);
      }
    });

    document.addEventListener("submit", function (event) {
      var form = event.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      event.preventDefault();
      var formData = new FormData(form);
      var variantId = formData.get("id");
      var quantity = formData.get("quantity") || 1;
      if (variantId) addVariant(variantId, quantity);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") setCartOpen(false);
    });
  }

  window.CasephonCart = {
    addVariant: addVariant,
    checkout: function () {
      refreshCart().then(function (cart) {
        if (cartCount(cart) > 0) window.location.href = "/checkout";
      });
    },
    close: function () { setCartOpen(false); },
    open: function () {
      refreshCart().finally(function () { setCartOpen(true); });
    },
    refresh: refreshCart,
    totalCount: function () { return cartCount(state.cart); }
  };

  ensureCartShell();
  bindEvents();
  refreshCart().then(function () {
    if (document.querySelector("[data-open-bag-on-load]") || window.location.pathname.replace(/\/$/, "") === "/cart") {
      setCartOpen(true);
    }
  });
})();

